import React from "react";
import { Box, Typography, Paper, Stack } from "@mui/material";

export default function TimetableLane({ title, items = [] }) {
  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 1.5, fontWeight: 700 }}>
        {title}
      </Typography>

      <Paper sx={{ p: 2, minHeight: 100 }}>
        {items.length === 0 ? (
          <Typography variant="body2" color="text.secondary">
            No groups scheduled
          </Typography>
        ) : (
          <Stack spacing={1}>
            {items.map((item, index) => (
              <Typography key={item.id || item.name || `item-${index}`}>
                {item.name || "Untitled group"}
              </Typography>
            ))}
          </Stack>
        )}
      </Paper>
    </Box>
  );
}